export default __webpack_public_path__ + "i18n/translations/translation-da.05a3808b.json";